import { atom } from 'recoil'

export const templatesState = atom({
  key: 'carousel__templatesState',
  default: {
    templates: [],
    loaded: false,
    loading: false,
    error: false
  }
})

export const templatePreviewState = atom({
  key: 'campaign__templatePreviewState',
  default: {
    idTemplate: 0,
    body: undefined
  }
})
